import { useContext, useState } from 'react';
import './search-page.css';
import { cartContext } from '../App';
import ProductInfoCard from './productInfoCard';
import { useNavigate } from 'react-router-dom';

export default function SearchPage() {

    const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
    const AUTH_TOKEN = process.env.REACT_APP_AUTH_TOKEN;

    const { productDataList, maxAmountReached } = useContext(cartContext);
    const [searchTerms, setSearchTerms] = useState('');
    const [searchItems, setSearchItems] = useState('');
    const navigate = useNavigate();

    function back() {
        navigate(-1);
    }

    function clear() {
        setSearchTerms('');
    }

    function handleKeyDown(e) {
        if (e.key === 'Enter') {
            e.target.blur()
            setSearchItems(searchTerms)
            console.log(searchTerms)

            const dataToSend = {
                searchItems: searchTerms
            }

            fetch(`${BACKEND_URL}/search-items`, {
                method: 'post',
                headers: {
                    'Authorization': `Bearer ${AUTH_TOKEN}`,  // Send token in header 
                    'content-type': 'application/json'
                },
                body: JSON.stringify(dataToSend),
            }).then((response) => response.json())
            .then((data) => {
                console.log(data)
            }).catch((error) => {
                console.log(error)
            })
        }
    }

    // const filteredData = searchTerms.length > 1 ? productDataList.filter((data) => data.data.title.toLowerCase().includes(searchTerms.toLowerCase())) : [];

    // const filteredData = searchTerms.length > 1 
    // ? productDataList.filter((data) => {
    //     const title = data.data.title.toLowerCase();
    //     const desc = data.data.description.toLowerCase();
    //     const category = data.data.category.toLowerCase();
    //     const terms = searchTerms.toLowerCase().split(/\s+/); // Split searchTerms into individual characters
    //     return terms.some(char => title.includes(char) || desc.includes(char)); // Check if any character is in the title
    //   }) 
    // : [];
    
    const filteredData = searchTerms.length > 1 
    ? productDataList
        .map((data) => {
            const title = data.data.title.toLowerCase();
            const desc = data.data.description.toLowerCase();
            const terms = searchTerms.toLowerCase().split(/\s+/);

            // Calculate the number of matched characters
            const matchCount = terms.reduce((count, char) => {
                return count + (title.includes(char) ? 1 : 0)
                    + (desc.includes(char) ? 1 : 0);
            }, 0);

            return { ...data, matchCount }; // Add matchCount to the object
        })
        .filter(data => data.matchCount > 0) // Filter out items with no matches
        .sort((a, b) => b.matchCount - a.matchCount) // Sort by matchCount in descending order
    : [];


    return (
        <div className='search-page-box'>
            <div className='search-page-container'>
                <div style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
                    <button className='arrow-back' onClick={back}>
                        <img src='/icons/left-arrow.png' alt='back-arrow' style={{height:'14px', width:'14px'}} />
                    </button>
                </div>
                <input
                    type='text'
                    placeholder='Search for "body lotion"'
                    className='search-page-bar'
                    value={searchTerms}
                    onChange={(e) => setSearchTerms(e.target.value)}
                    autoFocus
                    onKeyDown={handleKeyDown}
                />
                {
                    // searchTerms && <span className='cross-link' onClick={clear}>&#10006;</span>
                    searchTerms && <img src='/icons/x-mark.png' alt='cross-logo' className='cross-link' onClick={clear} />
                }
            </div>
            {
                filteredData.length > 0 ?
                    <>
                        {
                            maxAmountReached && (
                                <div className="max-amount-reached">
                                    <p className="max-amount-reached-text">Maximum Quantity Reached!</p>
                                </div>
                            )
                        }
                        <p className='show-result-for'>Showing results for <span style={{fontWeight: 'bold'}}>"{ searchTerms }"</span></p>
                        <div className='search-page-list-container'>
                            <ProductInfoCard dataList={filteredData} />
                        </div>
                    </>    :
                    searchItems.length > 1 ? 
                        <div className='search-page-list-container'>
                            <p className='no-result-found'>No Result Found!</p>
                        </div> :
                        <div className='search-page-list-container'>
                            
                        </div>
            }
        </div>
    );
}